<template>
  <v-card outlined>
    <v-card-title>
      <v-row align="center">
        <v-col>
          <div class="title">Project info</div>
        </v-col>

        <v-col align="right">
          <v-btn outlined color="secondary">Archive</v-btn>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text>
      <v-divider class="pb-6"></v-divider>

      <project-create-edit-form
        @cancelled="
          $router.push({ name: 'project', params: { project_id: project.id } })
        "
      ></project-create-edit-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import ProjectCreateEditForm from '@/components/projects/ProjectCreateEditForm'

export default {
  name: 'ProjectSettings',
  components: {
    ProjectCreateEditForm
  },
  computed: {
    ...mapState('projects', ['project'])
  }
}
</script>
